var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var FormGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.5rem;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.5rem;\n"])));
export var FormLabel = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  margin-bottom: 4px;\n  font-family: ", ";\n  font-size: 14px;\n"], ["\n  margin: 0;\n  margin-bottom: 4px;\n  font-family: ", ";\n  font-size: 14px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
});
export var FormMessage = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  position: absolute;\n  top: 100%;\n  margin: 4px 0 0 0;\n"], ["\n  ", "\n\n  position: absolute;\n  top: 100%;\n  margin: 4px 0 0 0;\n"])), function (_a) {
    var positionTop = _a.positionTop;
    return (positionTop ? 'display: inline-block;' : '');
});
export var FormError = styled(FormMessage)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.danger;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
